import React, { useState, useEffect } from 'react';
import './AuditorioReserva.css';
import config, { getApiUrl } from './config';
import AdminReporte from './AdminReporte';

export default function AuditorioReserva({ onLogout, usuarioLogueado, isAdmin }) {
  const [currentView, setCurrentView] = useState('reserva');
  const [formData, setFormData] = useState({
    nombre: '',
    email: usuarioLogueado ? `${usuarioLogueado}` : '',
    telefono: '',
    departamento: '',
    auditorio: '',
    fecha: '',
    horaInicio: '',
    horaFin: '',
    motivo: '',
    capacidad: '',
    equipos: [],
    opcionales: []
  });

  const [mensaje, setMensaje] = useState('');
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erroresCampos, setErroresCampos] = useState({});
  const [aceptaCondiciones, setAceptaCondiciones] = useState(false);

  useEffect(() => {
    if (mensaje) {
      setMostrarPopup(true);
      // No se cierra automáticamente, solo se cerrará cuando el usuario haga clic en el botón
    }
  }, [mensaje]);



  // const auditorios = config.AUDITORIOS;
  const equiposDisponibles = config.EQUIPOS_DISPONIBLES;
  const opcionalesDisponibles = config.OPCIONALES_DISPONIBLES;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Limpiar error del campo cuando el usuario empiece a escribir
    if (erroresCampos[name]) {
      setErroresCampos(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleEquipoChange = (equipo) => {
    setFormData(prev => ({
      ...prev,
      equipos: prev.equipos.includes(equipo)
        ? prev.equipos.filter(e => e !== equipo)
        : [...prev.equipos, equipo]
    }));
  };

  const handleOpcionalesChange = (opcionales) => {
    setFormData(prev => ({
      ...prev,
      opcionales: prev.opcionales.includes(opcionales)
        ? prev.opcionales.filter(e => e !== opcionales)
        : [...prev.opcionales, opcionales]
    }));
  };

  // Función para obtener las horas disponibles según la fecha
  const getHorasDisponibles = (esInicio = true) => {
    if (!formData.fecha) return [];

    const fechaSeleccionada = new Date(formData.fecha + 'T00:00:00');
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    fechaSeleccionada.setHours(0, 0, 0, 0);

    const esSabado = fechaSeleccionada.getDay() === 6;
    const esHoy = fechaSeleccionada.getTime() === hoy.getTime();

    // Horarios base hasta 6 PM (para todos los días inicialmente)
    let horasDisponibles = [
      { value: "06:00", label: "6:00 AM" },
      { value: "06:30", label: "6:30 AM" },
      { value: "07:00", label: "7:00 AM" },
      { value: "07:30", label: "7:30 AM" },
      { value: "08:00", label: "8:00 AM" },
      { value: "08:30", label: "8:30 AM" },
      { value: "09:00", label: "9:00 AM" },
      { value: "09:30", label: "9:30 AM" },
      { value: "10:00", label: "10:00 AM" },
      { value: "10:30", label: "10:30 AM" },
      { value: "11:00", label: "11:00 AM" },
      { value: "11:30", label: "11:30 AM" },
      { value: "12:00", label: "12:00 PM" },
      { value: "12:30", label: "12:30 PM" },
      { value: "13:00", label: "1:00 PM" },
      { value: "13:30", label: "1:30 PM" },
      { value: "14:00", label: "2:00 PM" },
      { value: "14:30", label: "2:30 PM" },
      { value: "15:00", label: "3:00 PM" },
      { value: "15:30", label: "3:30 PM" },
      { value: "16:00", label: "4:00 PM" },
      { value: "16:30", label: "4:30 PM" },
      { value: "17:00", label: "5:00 PM" },
      { value: "17:30", label: "5:30 PM" },
      { value: "18:00", label: "6:00 PM" }
    ];

    // Si NO es sábado, agregar horarios hasta 10 PM
    if (!esSabado) {
      horasDisponibles = horasDisponibles.concat([
        { value: "18:30", label: "6:30 PM" },
        { value: "19:00", label: "7:00 PM" },
        { value: "19:30", label: "7:30 PM" },
        { value: "20:00", label: "8:00 PM" },
        { value: "20:30", label: "8:30 PM" },
        { value: "21:00", label: "9:00 PM" },
        { value: "21:30", label: "9:30 PM" },
        { value: "22:00", label: "10:00 PM" }
      ]);
    }

    // Si es hoy, filtrar por 4 horas de anticipación
    if (esHoy) {
      const ahora = new Date();
      const horaMinima = new Date(ahora.getTime() + 4 * 60 * 60 * 1000);

      // Redondear a la siguiente media hora
      let horasMin = horaMinima.getHours();
      let minutosMin = horaMinima.getMinutes();

      if (minutosMin > 0 && minutosMin <= 30) {
        minutosMin = 30;
      } else if (minutosMin > 30) {
        horasMin += 1;
        minutosMin = 0;
      }

      const horaLimiteString = horasMin.toString().padStart(2, '0') + ':' +
        minutosMin.toString().padStart(2, '0');

      horasDisponibles = horasDisponibles.filter(hora => {
        return hora.value >= horaLimiteString;
      });
    }

    // Para hora fin, filtrar según hora inicio
    if (!esInicio && formData.horaInicio) {
      horasDisponibles = horasDisponibles.filter(hora => {
        return hora.value > formData.horaInicio;
      });
    }

    return horasDisponibles;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones básicas - identificar campos específicos vacíos
    const errores = {};

    //console.log('Validando campos:', formData); // Debug

    if (!formData.nombre || formData.nombre.trim() === '') errores.nombre = 'Nombre es obligatorio';
    if (!formData.identificacion || formData.identificacion.trim() === '') errores.identificacion = 'Identificación es obligatoria';
    if (!formData.email || formData.email.trim() === '') errores.email = 'Email es obligatorio';
    if (!formData.fecha || formData.fecha.trim() === '') errores.fecha = 'Fecha es obligatoria';
    if (!formData.horaInicio || formData.horaInicio.trim() === '') errores.horaInicio = 'Hora de inicio es obligatoria';
    if (!formData.horaFin || formData.horaFin.trim() === '') errores.horaFin = 'Hora de fin es obligatoria';
    if (!formData.academico || formData.academico.trim() === '') errores.academico = 'Programa académico es obligatorio';
    if (!formData.asignatura || formData.asignatura.trim() === '') errores.asignatura = 'Asignatura es obligatoria';
    if (!formData.capacidad || formData.capacidad.toString().trim() === '') errores.capacidad = 'Capacidad es obligatoria';

    console.log('Errores encontrados:', errores); // Debug

    if (Object.keys(errores).length > 0) {
      setErroresCampos(errores);
      const camposFaltantes = Object.keys(errores).join(', ');
      setMensaje(`Faltan los siguientes campos: ${camposFaltantes}`);
      console.log('Estableciendo errores:', errores); // Debug
      return;
    }

    // Limpiar errores si todo está bien
    setErroresCampos({});

    // Validación de horarios
    if (formData.horaInicio >= formData.horaFin) {
      setMensaje(config.MENSAJES.HORARIO_INVALIDO);
      return;
    }

    // Validación de horario de servicio
    const fechaSeleccionada = new Date(formData.fecha);
    const esSabado = fechaSeleccionada.getDay() === 6;
    const horaInicio = parseInt(formData.horaInicio.split(':')[0]);
    const horaFin = parseInt(formData.horaFin.split(':')[0]);

    if (horaInicio < 6) {
      setMensaje('El horario de inicio debe ser desde las 6:00 AM');
      return;
    }

    if (esSabado && horaFin > 18) {
      setMensaje('Los sábados el horario máximo es hasta las 6:00 PM');
      return;
    } else if (!esSabado && horaFin > 22) {
      setMensaje('Los horarios de reserva son de 6:00 AM a 10:00 PM');
      return;
    }

    // Validación de 4 horas de anticipación
    const ahora = new Date();
    const fechaReserva = new Date(formData.fecha + 'T' + formData.horaInicio);
    const diferencia = fechaReserva.getTime() - ahora.getTime();
    const horasAnticipacion = diferencia / (1000 * 60 * 60);

    if (horasAnticipacion < 4) {
      setMensaje('La reserva debe realizarse con al menos 4 horas de anticipación');
      return;
    }

    setEnviando(true);

    try {
      // Llamada al backend para guardar la reserva
      const response = await fetch(getApiUrl(config.ENDPOINTS.RESERVA), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok && result.success) {
        // Mostrar popup de éxito
        setMensaje('¡Reserva enviada exitosamente!\nLos datos han sido guardados y se ha enviado un correo de la solicitud.');
        setMostrarPopup(true);

        // Ya no se limpia el formulario automáticamente
        // El formulario se limpiará cuando el usuario cierre el popup manualmente
      } else {
        setMensaje(result.message || 'Error al realizar la reserva. Intenta de nuevo.');
        setMostrarPopup(true);
      }
    } catch (error) {
      setMensaje('Error de conexión. Verifica tu conexión a internet.');
      setMostrarPopup(true);
    } finally {
      setEnviando(false);
    }
  };


  // Si el usuario es administrador y está en la vista de reportes, mostrar el componente AdminReporte
  if (isAdmin && currentView === 'reporte') {
    return (
      <AdminReporte
        onLogout={onLogout}
        usuarioLogueado={usuarioLogueado}
        onNavigate={setCurrentView}
      />
    );
  }

  return (
    <div className="reserva-container">
      <header className="reserva-header">
        <h1>🏛️ {config.APP_NAME}</h1>
        <div className="header-buttons">
          {isAdmin && (
            <button
              onClick={() => setCurrentView('reporte')}
              className="admin-button"
            >
              📊 Ver Reportes
            </button>
          )}
          <button onClick={onLogout} className="logout-btn">
            🚪 Cerrar Sesión
          </button>
        </div>
      </header>

      <div className="reserva-content">
        <div className="reserva-form-container">
          <h2>📋 Formulario de Reserva</h2>

          <div className="fecha-solicitud">
            <label>📅 Fecha de Solicitud:</label>
            <span className="fecha-actual">{new Date().toLocaleDateString('es-CO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}</span>
          </div>

          <form onSubmit={handleSubmit} className="reserva-form">
            <div className="form-section">
              <h3>👤 Información Personal</h3>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nombre">Nombre Completo *</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    required
                    placeholder="Tu nombre completo"
                    className={erroresCampos.nombre ? 'error' : ''}
                  />
                  {erroresCampos.nombre && <div className="error-message">{erroresCampos.nombre}</div>}
                </div>
                <div className="form-group">
                  <label htmlFor="identificacion">Identificacion *</label>
                  <input
                    type="text"
                    id="identificacion"
                    name="identificacion"
                    value={formData.identificacion}
                    onChange={handleInputChange}
                    required
                    placeholder="Tu identificación"
                    className={erroresCampos.identificacion ? 'error' : ''}
                  />
                  {erroresCampos.identificacion && <div className="error-message">{erroresCampos.identificacion}</div>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="telefono">Teléfono</label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    placeholder="+57 300 123 4567"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="usuario@usbcali.edu.co"
                    className={erroresCampos.email ? 'error' : ''}
                  />
                  {erroresCampos.email && <div className="error-message">{erroresCampos.email}</div>}
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>🏛️ Detalles de la Reserva</h3>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fecha">Fecha de Reserva *</label>
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    value={formData.fecha}
                    onChange={(e) => {
                      const fechaValue = e.target.value;

                      // Solo validar si hay un valor de fecha válido
                      if (fechaValue) {
                        // Crear fecha usando el formato YYYY-MM-DD directamente
                        const [year, month, day] = fechaValue.split('-').map(Number);
                        const selectedDate = new Date(year, month - 1, day); // month - 1 porque los meses van de 0-11
                        const dayOfWeek = selectedDate.getDay();

                        console.log('Fecha seleccionada:', fechaValue, 'Día de la semana:', dayOfWeek);

                        // Verificar si es domingo (0 = domingo)
                        if (dayOfWeek === 0) {
                          alert('Los domingos no están disponibles para reservas. Por favor selecciona otro día.');
                          e.target.value = '';
                          setFormData(prev => ({ ...prev, fecha: '' }));
                          return;
                        }
                      }

                      handleInputChange(e);
                      // Limpiar horas cuando cambie la fecha
                      setFormData(prev => ({
                        ...prev,
                        horaInicio: '',
                        horaFin: ''
                      }));
                    }}
                    required
                    min={new Date().toISOString().split('T')[0]}
                    onKeyDown={(e) => {
                      // Prevenir escritura manual
                      e.preventDefault();
                    }}
                    className={`date-input-no-sundays ${erroresCampos.fecha ? 'error' : ''}`}
                  />
                  {erroresCampos.fecha && <div className="error-message">{erroresCampos.fecha}</div>}
                  <small className="fecha-info">📝 Nota: Los domingos no hay servicio disponible</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="horaInicio">Hora de Inicio *</label>
                  <select
                    id="horaInicio"
                    name="horaInicio"
                    value={formData.horaInicio}
                    onChange={(e) => {
                      handleInputChange(e);
                      // Limpiar hora fin cuando cambie hora inicio
                      setFormData(prev => ({
                        ...prev,
                        horaFin: ''
                      }));
                    }}
                    required
                    className={erroresCampos.horaInicio ? 'error' : ''}
                  >
                    <option value="">Selecciona hora de inicio</option>
                    {getHorasDisponibles(true).map(hora => (
                      <option key={hora.value} value={hora.value}>
                        {hora.label}
                      </option>
                    ))}
                  </select>
                  <small className="hora-info">
                    {formData.fecha && new Date(formData.fecha + 'T00:00:00').getDay() === 6
                      ? 'Inicio desde: 6:00 AM'
                      : 'Inicio desde: 6:00 AM'}
                  </small>
                </div>

                <div className="form-group">
                  <label htmlFor="horaFin">Hora de Fin *</label>
                  <select
                    id="horaFin"
                    name="horaFin"
                    value={formData.horaFin}
                    onChange={handleInputChange}
                    required
                    disabled={!formData.horaInicio}
                    className={erroresCampos.horaFin ? 'error' : ''}
                  >
                    <option value="">Selecciona hora de fin</option>
                    {getHorasDisponibles(false).map(hora => (
                      <option key={hora.value} value={hora.value}>
                        {hora.label}
                      </option>
                    ))}
                  </select>
                  {erroresCampos.horaFin && <div className="error-message">{erroresCampos.horaFin}</div>}
                  <small className="hora-info">
                    {formData.fecha && new Date(formData.fecha + 'T00:00:00').getDay() === 6
                      ? 'Máximo hasta: 6:00 PM'
                      : 'Máximo hasta: 10:00 PM'}
                  </small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="academico">Programa Academico *</label>
                  <input
                    type="text"
                    id="academico"
                    name="academico"
                    value={formData.academico}
                    onChange={handleInputChange}
                    required
                    placeholder="Tu programa academico"
                    className={erroresCampos.academico ? 'error' : ''}
                  />
                  {erroresCampos.academico && <div className="error-message">{erroresCampos.academico}</div>}
                </div>
                <div className="form-group">
                  <label htmlFor="asignatura">Asignatura *</label>
                  <input
                    type="text"
                    id="asignatura"
                    name="asignatura"
                    value={formData.asignatura}
                    onChange={handleInputChange}
                    required
                    placeholder="Tu asignatura"
                    className={erroresCampos.asignatura ? 'error' : ''}
                  />
                  {erroresCampos.asignatura && <div className="error-message">{erroresCampos.asignatura}</div>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="capacidad">Cantidad de Asistentes *</label>
                  <input
                    type="number"
                    id="capacidad"
                    name="capacidad"
                    value={formData.capacidad}
                    onChange={handleInputChange}
                    required
                    placeholder="Solo numeros (30)"
                    className={erroresCampos.capacidad ? 'error' : ''}
                  />
                  {erroresCampos.capacidad && <div className="error-message">{erroresCampos.capacidad}</div>}
                </div>
              </div>

              <div className="form-group full-width">
                <label htmlFor="observaciones">Observaciones</label>
                <textarea
                  id="observaciones"
                  name="observaciones"
                  value={formData.observaciones}
                  onChange={handleInputChange}
                  placeholder="Describe brevemente sus observaciones... (opcional)"
                  rows="3"
                />
                {erroresCampos.observaciones && <div className="error-message">{erroresCampos.observaciones}</div>}
              </div>
            </div>

            <div className="form-section">
              <h3>⚙️ Equipos y Servicios</h3>

              <div className="equipos-grid">
                {equiposDisponibles.map(equipo => (
                  <label key={equipo} className="equipo-checkbox">
                    <input
                      type="checkbox"
                      checked={formData.equipos.includes(equipo)}
                      onChange={() => handleEquipoChange(equipo)}
                    />
                    <span>{equipo}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="form-section">
              <h3>🪑 Opciones del Espacio</h3>

              <div className="opcionales-grid">
                {opcionalesDisponibles.map(opcionales => (
                  <label key={opcionales} className="opcionales-checkbox">
                    <input
                      type="checkbox"
                      checked={formData.opcionales.includes(opcionales)}
                      onChange={() => handleOpcionalesChange(opcionales)}
                    />
                    <span>{opcionales}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="form-section submit-section">
              <div className="condiciones-checkbox-container">
                <label className="condiciones-checkbox">
                  <input
                    type="checkbox"
                    checked={aceptaCondiciones}
                    onChange={(e) => setAceptaCondiciones(e.target.checked)}
                  />

                  <span>
                    Acepto condiciones de uso de auditorios USB Cali -{' '}
                    <a
                      href="https://usbcali.edu.co/wp-content/uploads/2026/02/Manual-de-Uso-Auditorios-y-Salas-de-Biblioteca.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      leer aquí
                    </a>
                  </span>

                </label>
              </div>
              <button type="submit" className="submit-btn" disabled={enviando || !aceptaCondiciones}>
                {enviando ? '⏳ Enviando...' : '📋 Solicitar Reserva'}
              </button>
            </div>
          </form>

          {mensaje && (
            <div className={`mensaje ${mensaje.includes('exitosamente') ? 'exito' : 'error'}`}>
              {mensaje}
            </div>
          )}
        </div>

        <div className="reserva-info">
          <h3>ℹ️ Información del Auditorio</h3>
          {/*           
            {auditorioSeleccionado ? (
              <div className="auditorio-details">
                <h4>{auditorioSeleccionado.nombre}</h4>
                <p><strong>Capacidad:</strong> {auditorioSeleccionado.capacidad} personas</p>
                <p><strong>Ubicación:</strong> {auditorioSeleccionado.ubicacion}</p>
                <p><strong>Equipos incluidos:</strong> Proyector, WiFi, Aire Acondicionado</p>
              </div>
            ) : (
              <p>Selecciona un auditorio para ver sus detalles</p>
            )} 
          */}

          <div className="reserva-tips">
            <h4>💡 Consejos para tu reserva:</h4>
            <ul>
              <li>Reserva con al menos {config.VALIDACIONES.MIN_HORAS_ANTICIPACION} horas de anticipación</li>
              <li>Si durante dos veces consecutivas y sin avisar previamente a Audiovisuales, no utiliza la sala o los equipos que hubiere reservado, esto puede ocasionarle la no prestación del servicio, durante el resto del semestre.</li>
              <li>Llega 15 minutos antes de tu evento</li>
              <li>No se permite el consumo de alimentos y/o Bebidas al interior del auditorio.</li>
            </ul>
          </div>
        </div>

      </div>

      {/* Popup de confirmación */}
      {mostrarPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="popup-icon">
              {mensaje.includes('exitosamente') ? '✅' : '❌'}
            </div>
            <div className="popup-message">
              {mensaje}
            </div>
            <button
              className="submit-btn"
              onClick={() => {
                setMostrarPopup(false);
                // Si el mensaje es de éxito, limpiar solo los datos de la reserva pero mantener los datos personales
                if (mensaje.includes('exitosamente')) {
                  setFormData(prevData => ({
                    // Mantener datos personales
                    nombre: prevData.nombre,
                    identificacion: prevData.identificacion,
                    email: prevData.email,
                    telefono: prevData.telefono,
                    // Limpiar datos de la reserva
                    academico: '',
                    asignatura: '',
                    fecha: '',
                    horaInicio: '',
                    horaFin: '',
                    observaciones: '',
                    capacidad: '',
                    equipos: [],
                    opcionales: []
                  }));
                  setMensaje('');
                }
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
